import { FETCH_OFFERS, REQUEST_OFFERS } from '../actions/Types'

const fetchOffers = (state={loading: false, data: []}, action) => {
    switch(action.type){
        case REQUEST_OFFERS:
            return { loading: true, data: []}
        case FETCH_OFFERS:
            return {loading: false, data: action.payload}
        default:
            return state
    }
}

export default fetchOffers